import { __awaiter, __generator } from "tslib";
import { z } from 'zod';
export function isValidURL(src) {
    return z.string().url().safeParse(src).success;
}
export function getUach() {
    return __awaiter(this, void 0, void 0, function () {
        var userAgentData, _a, architecture, bitness, fullVersionList, mobile, platformVersion, fullVersionListStr;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userAgentData = window.navigator.userAgentData;
                    if (!userAgentData || !(userAgentData === null || userAgentData === void 0 ? void 0 : userAgentData.getHighEntropyValues)) {
                        return [2 /*return*/, {}];
                    }
                    return [4 /*yield*/, userAgentData.getHighEntropyValues([
                            'architecture',
                            'bitness',
                            'platformVersion',
                            'fullVersionList',
                        ])];
                case 1:
                    _a = _b.sent(), architecture = _a.architecture, bitness = _a.bitness, fullVersionList = _a.fullVersionList, mobile = _a.mobile, platformVersion = _a.platformVersion;
                    fullVersionListStr = fullVersionList === null || fullVersionList === void 0 ? void 0 : fullVersionList.map(function (v) { return "\"".concat(v.brand, "\";v=\"").concat(v.version, "\""); }).join(', ');
                    return [2 /*return*/, {
                            uach_arch: architecture,
                            uach_bitness: bitness,
                            uach_full_version_list: fullVersionListStr,
                            uach_platform_version: platformVersion,
                            uach_wow64: "".concat(mobile),
                        }];
            }
        });
    });
}
